import { BrowserRouter, Routes, Route } from "react-router-dom";
import LinkFetcher from "./components/linkfetcher";
import "./App.css"; 

function App() {
  return (
    <>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LinkFetcher />} />
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
